module.exports = __webpack_public_path__ + "img/13.d54ac565.jpg";